<template>
    <div role="status" class="loading-balls-root">
        <div class="loading-balls-container">
            <span style="animation-delay: 0ms"></span>
            <span style="animation-delay: 100ms"></span>
            <span style="animation-delay: 250ms"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingBalls',
    };
</script>
